import { Fragment } from "react";
import { Card, CardBody, Col, Container, Row } from "reactstrap";
import { Breadcrumbs, P } from "../../../AbstractElements";
import { Pages, SampleCardTitle, SamplePageTitle } from "../../../Constants/Constants";
import { SampleCardData, SamplePageSubTitle } from "../../../Data/Pages/Pages";
import CommonCardHeader from "../../CommonComponents/CommonCardHeader/CommonCardHeader";

const SamplePageContainer = () => {
  return (
    <Fragment>
      <Breadcrumbs mainTitle={SamplePageTitle} parent={Pages} />
      <Container fluid>
        <Row>
          <Col sm="12">
            <Card>
              <CommonCardHeader title={SampleCardTitle} span={SamplePageSubTitle} />
              <CardBody>
                {SampleCardData.map((item, index) => (
                  <P key={index}>
                    <strong>{item.title}</strong>
                    {item.content}
                  </P>
                ))}
              </CardBody>
            </Card>
          </Col>
        </Row>
      </Container>
    </Fragment>
  );
};

export default SamplePageContainer;
